module.exports = __webpack_public_path__ + "static/donghyun_kim-ce5989af8533d3fbf9176f0c6ed50255.png";